import {
   randNumber,
   randPhrase,
   randLine,
   randRecentDate,
   randFullName,
   randEmail,
} from '@ngneat/falso';
import { optional } from '@library/common/functions';
import { DatePipe } from '@angular/common';

import { MockAttachment } from '@library/common/models/mock';

import { CartageItemTypes } from '../cartage-item-types';
import { CartageMilestones } from '../milestones';

import { dateTimeFormat } from '@library/common/models';

import { CartageDetail } from '../cartage-detail';

import { MockCartageBase } from './cartage-base.mock';
import { MockCartageDetailItem } from './cartage-detail-item.mock';
import { MockCartageCharge } from './cartage-charge.mock';
import { MockCartagePod } from './cartage-pod.mock';

import moment from 'moment';

export class MockCartageDetail extends CartageDetail {
   constructor( type?: CartageItemTypes ) {
      super({
         ...new MockCartageBase( type ) as any,
      });

      if ( optional() ) { this.pickupInstructions = optional( 80 ) ? randPhrase() : randLine(); }
      if ( optional() ) { this.deliveryInstructions = optional( 80 ) ? randPhrase() : randLine(); }

      this.items = Array.from({ length: randNumber({ min: 1, max: 10 }) }, _ => new MockCartageDetailItem() );

      this.charges = Array.from({ length: randNumber({ min: 1, max: 20 }) }, _ => new MockCartageCharge() );

      if ( optional() ) { this.notes = Array.from({ length: randNumber({ max: 3 })}, _ => mockCartageNote() ).join( `\r\n` ); }

      this.attachments = Array.from({ length: randNumber({ max: 3 })}, _ => new MockAttachment() );

      if ( optional( 40 ) ) { this.pod = new MockCartagePod(); }

      this.milestones = CartageMilestones( this.type );
      Object.keys( this.milestones ).map( key =>
         this.milestones[key] = optional() ? moment( randRecentDate({ days: 10 })).format( dateTimeFormat ) : null );
   }
}

function mockCartageNote() {
   const date = new DatePipe('en').transform( randRecentDate({ days: 10 }), 'medium' );
   const user = optional( 80 ) ? randFullName() : randEmail();
   const note = randLine({ lineCount: randNumber({ min: 5, max: 10 })});

   return `[ ${date} - VP ${user} ] \r\n ${note} \r\n`;
}
